export default "__VITE_ASSET__DR1z7_3k__"